import request from "utils/request";
import { route } from "preact-router";

export async function fetchLink(props, url, location) {
  const URL = "klinik/?url=" + url;
  const header = {
    method: "GET",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
  };

  try {
    const link = await request(URL, header);
    const target = link.target;
    const category = link.category ? link.category : props.matches.category;
    const version = props.matches.version;
    const cohort = props.matches.cohort;
    route(`/${target}?category=${category}&location=${location}&url=${url}&version=${version}&cohort=${cohort}`);
  } catch (err) {
    console.log(err);
  }
}